<template>
  <div>
    <div class="nav-wrap" style="height: 60px;padding-top:20px;">
      <!-- // 导航栏 中间的标题 -->
      <div
        style="display: flex; justify-content: space-around;flex-direction: column;position:relative;bottom:25px"
      >
        <!-- // 导航栏 左上角的返回按钮 和home按钮 // 其中v-if='{{navbarData.showCapsule}}' 是控制左上角按钮的显示隐藏，首页不显示 -->
        <!-- //左上角的返回按钮，v-if='{{!share}}'空制返回按钮显示 //从分享进入小程序时 返回上一级按钮不应该存在 -->
        <div class="nav-title">{{ this.title }}</div>
        <div
          class="nav-capsule"
          style="height: 80px;"
          v-if="navbarData.showCapsule"
        >
          <!-- <div @click="_navback" v-if="!share">
            <img src="/static/back_icon.png" mode="aspectFill" class="back-pre" />
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'navbar',
  props: {
    title: {}
  },
  data () {
    return {
      height: '',
      // 默认值  默认显示左上角
      navbarData: {
        showCapsule: 1
      }
    }
  },
  methods: {
    // 返回上一页面
    _navback () {
      wx.navigateBack()
    }
  }
}
</script>

<style scoped lang="scss">
/* 顶部要固定定位   标题要居中   自定义按钮和标题要和右边微信原生的胶囊上下对齐 */
.nav-wrap {
  position: fixed;
  width: 100%;
  top: 0;
  background: #fff;
  color: #000;
  z-index: 99999;
}
/* 标题要居中 */
.nav-title {
  /* position: absolute;
  text-align: center;
  max-width: 400px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0; */
  position: relative;
  top: 43px;
  margin: 0 auto;
  font-size: 19px;
  color: #000;
  /* font-weight: 600; */
}

.back-text {
  position: relative;
  color: #fff;
  font-size: 17px;
  top: -7px;
  right: 2px;
}

.nav-capsule {
  display: flex;
  /* align-items: center; */
  margin-left: 15px;
  width: 70px;
  justify-content: space-between;
  height: 100%;
}

.navbar-v-line {
  width: 1px;
  height: 16px;
  background-color: #e5e5e5;
}

.back-pre,
.back-home {
  width: 10px;
  height: 15px;
  margin-top: 20px;
  padding: 5px;
}
.nav-capsule .back-home {
  width: 18px;
  height: 20px;
  margin-top: 2px;
}
</style>
